import { Paper, Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  SaveButton,
  SubmitButton,
} from '../../components/common/button/CustomButtons';
import formatDate from '../../components/common/formatDate';
import ChildHeader from '../../components/ui/ChildHeader';
import { useQuery } from '../../hooks/UseQuery';
import { useAuth } from '../../services/auth/AuthProvider';
import TController from './components/create/TController';
import useGetData from './helpers/useGetData';
import { CustomButton } from '../../components/common/button/CustomButtons';
import VisibilityIcon from '@mui/icons-material/Visibility';
interface MyData {
  moduleData: any; // replace PirType with the type of your `pir` data
  isLoading: boolean;
  error?: string | null;
  // machineData?: any;
  // autoCompleteMachineValue?: any;
  // setAutoCompleteMachineValue?: any;
}
const Create = () => {
  const { partId, pirId } = useParams();
  const [tabValue, setTabValue] = useState(0);
  const { state } = useAuth();
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const partName = useQuery('partName');
  const partNumber = useQuery('partNumber');
  const {
    moduleData,
    isLoading,
    error,
  }: // machineData,
  // autoCompleteMachineValue,
  // setAutoCompleteMachineValue,
  MyData = useGetData(partId, pirId);

  const onSubmit = async (isSubmitted: boolean) => {
    moduleData.isSubmitted = isSubmitted;
    moduleData.is_admin_request = 'pending';
    moduleData.report_prepared_by = state.user?.name;
    let response: any;
    if (moduleData._id) {
      response = await axios
        .put(`/api/pir/${moduleData._id}`, moduleData)
        .catch((err) => console.log(err));
    } else {
      response = await axios
        .post(`/api/pir`, moduleData)
        .catch((err) => console.log(err));
    }

    if (response.data && state.user?.userType === 3 && isSubmitted) {
      const messageData = {
        category: 'PIR',
        title: 'PIR CREATED',
        user: 'admin',
        body: `PIR Report of "${partName}" ${
          moduleData._id ? 'updated' : 'submitted'
        } by "${state.user?.name}" on ${formatDate(new Date())}`,
        link: `/admin/pir/${partId}/${response.data._id}?partNumber=${partNumber}&partName=${partName}&isView=true`,
      };
      axios
        .post(`/api/notification`, messageData)
        .then(() => {
          if (moduleData._id) {
            alert('updated successfully ');
            return;
          }
          alert('created successfully');
          navigate(-1);
        })
        .catch((err) => console.log(err));
      return;
    }
    if (moduleData._id && !isSubmitted) {
      alert('updated successfully ');
      return;
    }
    alert('created successfully');
    navigate(-1);
  };

  //const fetchLatestPPS = async () => {
  //  try {
  //    const response = await axios.get(`/api/ppsListRoute/latest/${moduleData.part_id._id}`);
  //    if (response.data && response.data.files && response.data.files.length > 0) {
  //      const fileUrl = response.data.files[0].url;
  //      if (fileUrl) {
  //        if (response.data.files[0].name.includes('.xlsx') || response.data.files[0].name.includes('.xls')){
  //          window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl,)}`, '_blank');
  //        }
  //        window.open(fileUrl, '_blank');
  //      } else {
  //        alert('The PPS document does not have a valid URL.');
  //      }
  //    } else {
  //      alert('No PPS document found for this part or the document has no files.');
  //    }
  //  } catch (error) {
  //    console.error('Error fetching latest PPS:', error);
  //    alert('Error fetching latest PPS document. Please try again.');
  //  }
  //};
  //
  return (
    <Box>
      <Box>
        <ChildHeader text="PIR">
          {/*
          <CustomButton
              icon={<VisibilityIcon />}
              sx={{ margin: '10px', backgroundColor: '#fff', color: '#111' }}
              onClick={fetchLatestPPS}
            >
              VIEW PPS
          </CustomButton>
          */}
          
          {!isView && (
            <>
              {state.user?.userType === 3 && (
                <SaveButton
                  label="Save & Continue"
                  onClick={() => onSubmit(false)}
                />
              )}
              <SubmitButton label="Submit" onClick={() => onSubmit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <Paper elevation={2}>
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(+newValue)}
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          textColor="secondary"
        >
          {moduleData &&
            moduleData.pirs.map((pir: any) => <Tab label={pir.process_name} />)}
        </Tabs>
      </Paper>
      <TController
        {...{
          moduleData,
          tabValue,
          isView,
          // machineData,
          // autoCompleteMachineValue,
          // setAutoCompleteMachineValue,
        }}
      />
    </Box>
  );
};

export default Create;
